<template>
  <div :ref="chartRefId" style="width: 100%; height: 400px;"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'DonutChartScore',
  props: {
    skipped: { type: Number, required: true },
    incorrect: { type: Number, required: true },
    correct: { type: Number, required: true },
  },
  data() {
    return {
      chartRefId: `donut-chart-${this._uid}`,
      chartInstance: null
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      const chartEl = this.$refs[this.chartRefId];
      if (!chartEl) return;

      this.chartInstance = echarts.init(chartEl);

      const { skipped, incorrect, correct } = this;

/*       const used = skipped + incorrect + correct;
      const remaining = Math.max(max - used, 0); // For visual consistency */

      const data = [
        { name: 'Skipped', value: skipped },
        { name: 'Incorrect', value: incorrect },
        { name: 'Correct', value: correct },
        // optionally show unused if max > used
        // { name: 'Unattempted', value: remaining }
      ];

      this.chartInstance.setOption({
        title: {
          text: 'Score Breakdown',
          left: 'center',
          top: 10
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {d}% ({c})'
        },
        legend: {
          bottom: 10,
          left: 'center'
        },
        series: [
          {
            name: 'Score',
            type: 'pie',
            radius: ['50%', '75%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'outside',
              formatter: '{b}\n{d}%'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: 'bold'
              }
            },
            data
          }
        ]
      });

      window.addEventListener('resize', this.resizeChart);
    },
    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    getChartInstance() {
      return this.chartInstance;
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
};
</script>
